import type { ColumnType, Generated, Selectable } from 'kysely'
import { z } from 'zod'

export type McpServerEntity = {
  id: Generated<string>
  teamUid: string
  name: string
  createdAt: ColumnType<string, never, never>
  updatedAt: ColumnType<string, never, never>
}

export type McpServer = Selectable<McpServerEntity>

export const mcpServerSchema = z
  .object({
    id: z.string(),
    teamUid: z.string(),
    name: z.string(),
    createdAt: z.string(),
    updatedAt: z.string(),
  })
  .meta({ id: 'mcp-server' }) satisfies z.ZodType<McpServer>

export type McpServerOperationToolEntity = {
  id: Generated<string>
  mcpServerId: string
  operationId: string
  searchToolEnabled: boolean
  executeRequestToolEnabled: boolean
  createdAt: ColumnType<string, never, never>
  updatedAt: ColumnType<string, never, never>
}

export type McpServerOperationTool = Selectable<McpServerOperationToolEntity>

export const mcpServerOperationToolSchema = z
  .object({
    id: z.string(),
    mcpServerId: z.string(),
    operationId: z.string(),
    searchToolEnabled: z.boolean(),
    executeRequestToolEnabled: z.boolean(),
    createdAt: z.string(),
    updatedAt: z.string(),
  })
  .meta({
    id: 'mcp-server-operation-tool',
  }) satisfies z.ZodType<McpServerOperationTool>

export type McpInstallationEntity = {
  id: Generated<string>
  mcpServerId: string
  name: string
  documentAuth: Record<string, unknown>
}

export type McpInstallation = Selectable<McpInstallationEntity>

export const mcpInstallationSchema = z
  .object({
    id: z.string(),
    mcpServerId: z.string(),
    name: z.string(),
    documentAuth: z.record(z.string(), z.unknown()),
  })
  .meta({ id: 'mcp-installation' }) satisfies z.ZodType<McpInstallation>
